export default {
  ledgerPushApi: {
    getPushLogList: 'api/ledgerPush/getPushLogList',
    rePushTool: 'api/ledgerPush/rePushTool',
    rePushAll: 'api/ledgerPush/rePushAll',
    getRepushList: 'api/ledgerPush/getRepushList'
  }
}
